import React from 'react';

function Services() {
  return (
    // <div className="bg-gradient-to-r  from-gray-200 to-gray-300 p-12 py-12">
      <div className="mt-1 w-full lg:max-w-6xl  ml-2 lg:ml-1 mx-auto bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-lg shadow-md p-1 lg:p-1 px-1 lg:px-32 ">

      <h1 className="text-3xl font-bold text-center my-8 service-box ">MY SERVICES</h1>
      <div className="max-w-7xl mx-auto grid gap-8 md:grid-cols-2 lg:grid-cols-2">
        <div className="service-box bg-gradient-to-br from-yellow-200 to-yellow-400 rounded-lg p-6 shadow-md">
          <h5 className="text-xl font-bold mb-4">Frontend Development</h5>
          <p className="text-gray-700">
            Specializing in building interactive and responsive user interfaces with modern frontend technologies.
          </p>
        </div>
        <div className="service-box bg-gradient-to-br from-blue-200 to-blue-400 rounded-lg p-6 shadow-md">
          <h5 className="text-xl font-bold mb-4">Full Stack Development</h5>
          <p className="text-gray-700">
            Offering end-to-end development services from frontend to backend, ensuring robust and scalable applications.
          </p>
        </div>
        <div className="service-box bg-gradient-to-br from-green-200 to-green-400 rounded-lg p-6 shadow-md">
          <h5 className="text-xl font-bold mb-4">MERN Stack Development</h5>
          <p className="text-gray-700">
            Expertise in MongoDB, Express.js, React, and Node.js stack for building modern and efficient web applications.
          </p>
        </div>
        <div className="service-box bg-gradient-to-br from-purple-200 to-purple-400 rounded-lg p-6 shadow-md">
          <h5 className="text-xl font-bold mb-4">Web Development</h5>
          <p className="text-gray-700">
            Comprehensive web development solutions tailored to meet your business objectives and user needs.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Services;

// import React from 'react';

// function Services() {
//   return (
//     <div style={{ backgroundImage: `url(/images/bg-effect-1.png)` }}>
//       <h1 className="my-service-heading">MY SERVICES</h1>
//       <div className="service-container">
//         <div className="service-box-web">
//           <h5>Web Design</h5>
//           <p>
//             Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
//             eiusmod tempor incididunt ut labore et dolore magna aliqua.
//           </p>
//         </div>
//         <div className="service-box-dev">
//           <h5>Development</h5>
//           <p>
//             Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
//             eiusmod tempor incididunt ut labore et dolore magna aliqua.
//           </p>
//         </div>
//         <div className="service-box-seo">
//           <h5>SEO Marketing</h5>
//           <p>
//             Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
//             eiusmod tempor incididunt ut labore et dolore magna aliqua.
//           </p>
//         </div>
//         <div className="service-box-webd">
//           <h5>Web Design</h5>
//           <p>
//             Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
//             eiusmod tempor incididunt ut labore et dolore magna aliqua.
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Services;
